import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { reactLocalStorage } from "reactjs-localstorage";
import {
  Row,
  Col
} from "reactstrap";
import Switch from "react-switch";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  EMPTY_DATA,
  defaultPageSize,
} from "../../../../config/constants";
import {
  getConfigurationKey,
  handleDepartmentHeader,
  searchNocontentFilter,
} from "../../../../helper";
import NoContentFound from "../../../common/NoContentFound";
import LoaderCustom from "../../../common/LoaderCustom";
import Toaster from "../../../common/Toaster";
import { PaginationWrapper } from "../../../common/commonPagination";
import Button from "../../../layout/Button";
import CustomDateRangeFilter from "../../supplierNewRequestHistory/common/CustomDateRangeFilter ";
import { ApplyPermissionSupplierOnboarding } from "../index";
import { setSelectedRowForPagination } from "../../../simulation/actions/Simulation";
import WarningMessage from "../../../common/WarningMessage";
import {
  updateCurrentRowIndex,
  updatePageNumber,
} from "../../../common/Pagination/paginationAction";
import ReactExport from "react-export-excel";
import { fetchBlockedSupplierExport,  supplierListing } from "../Actions";
import _ from "lodash";
import {
  BLOCKED_EMPLOYER_EXPORT,
} from "../../../../config/masterData";
import { CustomPagination } from "./CustomPagination";
import AddUnblockingRequest from "../AddUnblockingRequest";
import DayTime from "../../../common/DayTimeWrapper";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const BlockedEmployer = (props) => {

  const {

  } = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [gridApi, setgridApi] = useState(null); // DONT DELETE THIS STATE , IT IS USED BY AG GRID
  const [filter, setFilter] = useState("3");
  const [pageSize, setPageSize] = useState({
    pageSize10: true,
    pageSize50: false,
    pageSize100: false,
  });
  const { isSimulation, sideBarFilterData, setDataForUnblockingRequest } = props;
  const [disableDownload] = useState(false);
  const [inRangeDate, setinRangeDate] = useState([])


  const [filterModel, setFilterModel] = useState({});

  const [setgridColumnApi] = useState(null);
  const permissions = useContext(ApplyPermissionSupplierOnboarding);
  const [btnextData, setBtNexData] = useState({})

  const [dataCount, setDataCount] = useState(0);
  const [warningMessage, setWarningMessage] = useState(false);
  const [loader, setloader] = useState(false);
  const [vendorUnblockingRequest, setVendorUnblockingRequest] = useState("main")
  const onBtPrevious = (p, pSize) => {
    
    setloader(true);
    // Calculate the previous page number
    setPageNo(p);
  
    // Dispatch the action with updated filters including the new page number
    dispatch(
      supplierListing({
        ...props?.filters,
        current_page: p, // Update current page to the previous page
        per_page: pSize, // Use the passed page size or set it to your default value
        btnextData,
      }, (response, error) => {
        // Set loading to false when the request completes (success or error)
        setloader(false);
        
        if (error) {
          // Handle error case
          
        }
      })
    );
  };
  // const onBtNext = (p, pSize) => {
  //   // Update the pageNo state
  //   setPageNo(p);

  //   // Dispatch the action with updated filters including the current page number
  //   dispatch(
  //     supplierListing({
  //       ...props?.filters,
  //       current_page: p, // Update current page to the next page
  //       per_page: pSize,
  //       btnextData, // Ensure this is correctly included
  //     })
  //   );
  // };
  const onBtNext = (p, pSize) => {
    // Set loading to true when starting the request
    setloader(true);
  
    // Update the pageNo state
    setPageNo(p);
  
    // Dispatch the action with updated filters including the current page number
    dispatch(
      supplierListing({
        ...props?.filters,
        current_page: p, // Update current page to the next page
        per_page: pSize,
        btnextData,
      }, (response, error) => {
        // Set loading to false when the request completes (success or error)
        setloader(false);
        
        if (error) {
          // Handle error case
          
        }
      })
    );
  };
  const { blockedSuppliers, loading } = useSelector(
    (state) => state?.AllSupplierHistorySlice
  );
  const { blockedEmployerExport } = useSelector(
    (state) => state?.BlockedSupplierRequest
  );


  const [isFilterButtonClicked, setIsFilterButtonClicked] = useState(false);
  const [pageNoNew, setPageNoNew] = useState(1);
  const [pageNo, setPageNo] = useState(1);
  const [currentRowIndex, setCurrentRowIndex] = useState(0);
  const [disableFilter, setDisableFilter] = useState(true); // STATE MADE FOR CHECKBOX IN SIMULATION
  const { selectedRowForPagination } = useSelector((state) => state.simulation);
  const [dataForRequest, setDataForRequest] = useState(null)
  const [dataForRequestVendorCode, setDataForRequestVendorCode] = useState(null)
  const FilterPotential = props?.filter;
  const [filters, setFilters] = useState({
    current_page: 1,
    per_page: defaultPageSize,
    filter,
  });

  const [floatingFilterData, setFloatingFilterData] = useState({
    VendorCode: "",
    SupplierName: "",
    VendorCategory: "",
    BlockReason:"",
    RegistrationDate: "",
    ContactNumber: "",
    EmailAddress: "",
  });


  var filterParams = {
    date: "", inRangeInclusive: true, filterOptions: ['equals', 'inRange'],
    comparator: function (filterLocalDateAtMidnight, cellValue) {
      var dateAsString = cellValue != null ? DayTime(cellValue).format('DD/MM/YYYY') : '';
      var newDate = filterLocalDateAtMidnight != null ? DayTime(filterLocalDateAtMidnight).format('DD/MM/YYYY') : '';
      handleDate(newDate)// FOR COSTING BENCHMARK BOP REPORT
      let date = document.getElementsByClassName('ag-input-field-input')
      for (let i = 0; i < date.length; i++) {
        if (date[i].type == 'radio') {
          date[i].click()
        }
      }

      setDate(newDate)
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split('/');
      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
    },

    browserDatePicker: true,
    minValidYear: 2000,

  };
  var setDate = (date) => {
    setFloatingFilterData((prevState) => ({ ...prevState, RegistrationDate: date }));
  };

  var handleDate = (newDate) => {
    let temp = inRangeDate
    temp.push(newDate)
    setinRangeDate(temp)        // setState((prevState) => ({ ...prevState, inRangeDate: temp }))
    if (props?.benchMark) {
      props?.handleDate(inRangeDate)
    }
    setTimeout(() => {
      var y = document.getElementsByClassName('ag-radio-button-input');
      var radioBtn = y[0];
      radioBtn?.click()

    }, 300);
  }
  const dispatch = useDispatch();

  const history = useHistory();
  const [noData, setNoData] = useState(false);
  const onGridReady = (params) => {
    setgridApi(params.api);
    params.api.sizeColumnsToFit();
    setgridColumnApi(params.columnApi);
    params.api.paginationGoToPage(0);

    const checkBoxInstance = document.querySelectorAll(
      ".ag-input-field-input.ag-checkbox-input"
    );
    checkBoxInstance.forEach((checkBox, index) => {
      const specificId = `RM_Domestic_Checkbox${index / 11}`;
      checkBox.id = specificId;
    });
    const floatingFilterInstances = document.querySelectorAll(
      ".ag-input-field-input.ag-text-field-input"
    );
    floatingFilterInstances.forEach((floatingFilter, index) => {
      const specificId = `RM_Domestic_Floating${index}`;
      floatingFilter.id = specificId;
    });
  };
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;

    if (props?.isMasterSummaryDrawer) {
      return false;
    } else {
      return thisIsFirstColumn;
    }
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    // headerCheckboxSelection:
    //   isSimulation || props?.benchMark ? isFirstColumn : false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  // const getBlockedSupplierRequest = async (EmpId, floatingFilterData, filters) => {
  //   
  //   console.log("Dispatching fetchBlockedSupplierExport with params:", {
  //     RegistrationType: EmpId || 0, 
  //     ...floatingFilterData,
  //     ...filters
  //   });
  // };
  useEffect(() => {

    if (sideBarFilterData) {

      getBlockedSupplierRequest(props?.filter, null, sideBarFilterData);
    }
  }, [sideBarFilterData, props?.filter]);

  const getBlockedSupplierRequest = (EmpId, floatingFilterData, filters) => {


    try {
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      dispatch(
        fetchBlockedSupplierExport({
          RegistrationType: EmpId,
          ...floatingFilterData,
          ...filters
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      setloader(false);
    }
  };

  useEffect(() => {

    getBlockedSupplierRequest(props?.filter || {});
  }, [props?.filter]);

  const onPageSizeChanged = (newPageSize) => {
    const pageSizeValue = Number(newPageSize);
    setPageNo(1);
    setPageSize({
      pageSize10: pageSizeValue === 10,
      pageSize50: pageSizeValue === 50,
      pageSize100: pageSizeValue === 100,
    });
    props?.setGlobalTake(pageSizeValue);

    // Check if the filters object is correctly passed
    const updatedFilters = { ...props?.filters, per_page: pageSizeValue, current_page: 1 };

    dispatch(supplierListing(updatedFilters));
  };
  const onRowSelect = (event) => {
    let selectedRowForPagination =
      reactLocalStorage.getObject("selectedRow").selectedRow;


    var selectedRows = gridApi && gridApi?.getSelectedRows();

    if (selectedRows === undefined || selectedRows === null) {
      //CONDITION FOR FIRST RENDERING OF COMPONENT
      selectedRows = selectedRowForPagination;
    } else if (
      selectedRowForPagination &&
      selectedRowForPagination.length > 0
    ) {
      // CHECKING IF REDUCER HAS DATA

      let finalData = [];
      if (event.node.isSelected() === false) {
        // CHECKING IF CURRENT CHECKBOX IS UNSELECTED

        for (let i = 0; i < selectedRowForPagination.length; i++) {
          if (
            selectedRowForPagination[i].VendorCode ===
            event.data.VendorCode
          ) {
            // REMOVING UNSELECTED CHECKBOX DATA FROM REDUCER
            continue;
          }
          finalData.push(selectedRowForPagination[i]);
        }
      } else {
        finalData = selectedRowForPagination;
      }
      selectedRows = [...selectedRows, ...finalData];
    }

    let uniqeArray = _.uniqBy(selectedRows, "VendorCode"); //UNIQBY FUNCTION IS USED TO FIND THE UNIQUE ELEMENTS & DELETE DUPLICATE ENTRY
    reactLocalStorage.setObject("selectedRow", { selectedRow: uniqeArray }); //SETTING CHECKBOX STATE DATA IN LOCAL STORAGE
    setDataCount(uniqeArray.length);
    dispatch(setSelectedRowForPagination(uniqeArray));
    let finalArr = selectedRows;
    let length = finalArr?.length;
    let uniqueArray = _.uniqBy(finalArr, "VendorCode");

    // if (isSimulation) {
    //   apply(uniqueArray, length);
    // }

    if (props?.benchMark) {
      let uniqueArrayNew = _.uniqBy(selectedRows, (v) =>
        [v.TechnologyId, v.RawMaterial].join()
      );

      if (uniqueArrayNew.length > 1) {
        dispatch(setSelectedRowForPagination([]));
        gridApi.deselectAll();
        Toaster.warning("Technology & Raw material should be same");
      }
    }
  };


  const onSearch = () => {
    // Initialize date variables
    let requestFromDate = null;
    let requestToDate = null;

    // Check if RegistrationDate exists in filterModel
    if (filterModel?.RegistrationDate) {
      if (filterModel.RegistrationDate.dateFrom) {
        requestFromDate = DayTime(filterModel.RegistrationDate.dateFrom).format('DD/MM/YYYY');
      } else {
        requestFromDate = null;
      }

      if (filterModel.RegistrationDate.dateTo) {
        requestToDate = DayTime(filterModel.RegistrationDate.dateTo).format('DD/MM/YYYY');
      } else {
        requestToDate = null;
      }
    }

    

    // Set other state values
    const updatedBtNexData = {
      ...floatingFilterData,
      requestFromDate,
      requestToDate
    };
  
    // Set other state values
    setBtNexData(updatedBtNexData);
    setNoData(false);
    setWarningMessage(false);
    setIsFilterButtonClicked(true);
    setPageNo(1);
    dispatch(updatePageNumber(1));
    setPageNoNew(1);
    dispatch(updateCurrentRowIndex(10));
    setCurrentRowIndex(0);
    gridOptions?.columnApi?.resetColumnState();

    // Dispatch the supplierListing action with date filters
    dispatch(
      supplierListing({
        ...props?.filters,
        FilterPotential,
        current_page: 1,
        per_page: props?.globalTake,
        floatingFilterData,
        requestFromDate, // Pass formatted dateFrom here or null
        requestToDate,   // Pass formatted dateTo here or null
      })
    );

    // Call getBlockedSupplierRequest with date filters
    getBlockedSupplierRequest(3, {
      ...floatingFilterData,
      requestFromDate,
      requestToDate
    });

    // Determine if filters should be reset

  };

  useEffect(() => {
    if (props?.usersWithSerialNumbers?.length !== 0) {
      setNoData(searchNocontentFilter(floatingFilterData, noData))

      let isReset = true;
      setloader(false);
      setTimeout(() => {
        for (const prop in floatingFilterData) {

          if (floatingFilterData[prop] !== "") {
            isReset = false;
          }
        }

        // Sets the filter model via the grid API

        isReset ? gridOptions?.api?.setFilterModel({}) : gridOptions?.api?.setFilterModel(filterModel);
      }, 300);

      setTimeout(() => {
        setWarningMessage(false);
      }, 335);

      setTimeout(() => {
        setIsFilterButtonClicked(false);
      }, 600);
    }
  }, [])


  const onFloatingFilterChanged = (value) => {
    setTimeout(() => {
      if (props?.usersWithSerialNumbers?.length !== 0) {
        setNoData(searchNocontentFilter(value, noData))
      }
    }, 500);

    setDisableFilter(false)
    const model = gridOptions?.api?.getFilterModel();
    setFilterModel(model)
    if (!isFilterButtonClicked) {
      setWarningMessage(true)
    }

    if (value?.filterInstance?.appliedModel === null || value?.filterInstance?.appliedModel?.filter === "") {
      let isFilterEmpty = true
      if (model !== undefined && model !== null) {
        if (Object.keys(model).length > 0) {
          isFilterEmpty = false

          for (var property in floatingFilterData) {

            if (property === value.column.colId) {
              floatingFilterData[property] = ""
            }
          }
          setFloatingFilterData(floatingFilterData)
        }

        if (isFilterEmpty) {
          setWarningMessage(false)
          for (var prop in floatingFilterData) {

            if (isSimulation && getConfigurationKey().IsCompanyConfigureOnPlant) {
              if (prop !== "DepartmentName") {
                floatingFilterData[prop] = ""
              }

            } else {
              floatingFilterData[prop] = ""
            }
          }
          setFloatingFilterData(floatingFilterData)
        }
      }

    } else {

      if (value.column.colId === "RegistrationDate" || value.column.colId === "RegistrationDate") {
        return false
      }
      setFloatingFilterData({ ...floatingFilterData, [value.column.colId]: value.filterInstance.appliedModel.filter })
    }

  }




  const resetState = async () => {
    history.push("/supplier-list-all");

  };

  const onBtExport = () => {
    let tempArr = [];

    //tempArr = gridApi && gridApi?.getSelectedRows()
    tempArr = selectedRowForPagination;
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : blockedEmployerExport?.data
          ? blockedEmployerExport?.data
          : [];
    return returnExcelColumn(BLOCKED_EMPLOYER_EXPORT, tempArr);
  };
  const returnExcelColumn = (data = [], TempData) => {
    return (
      <ExcelSheet data={TempData} name={'BlockedEmployerExport'}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={ele.value}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };
  const effectiveDateFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
  };
  const buttonFormatter = (props) => {


    props.api.sizeColumnsToFit();
    const handleView = () => {
      // Extract necessary IDs
      const requestId = props.data?.VendorRequirementRegistrationId;
      const nSAAuditDetailId = props.data?.NSAAuditDetailId;
      // Construct the base URL
      let url = `view-supplier-need-form?VendorRequirementRegistrationId=${requestId}`;
      // Append NSAAuditDetailId if it exists and is greater than 0
      if (nSAAuditDetailId && nSAAuditDetailId > 0) {
        url += `&nsaAuditDetailId=${nSAAuditDetailId}`;
      }
      // Navigate to the constructed URL
      history.push(url);
    };

    return (
      <div>

        <button
          title="Supplier Unblocking Request"
          class="create-rfq mr-1 p-relative"
          type="button"
          disabled={props?.data?.IsUnblockRequestInitiated}
          onClick={() => {
            if (!props.data?.IsReasonExistForUnblock) {
              Toaster.warning("Please contact MDM Team for Supplier unblock")
            } else {
              setVendorUnblockingRequest("add")
              setDataForUnblockingRequest("hide")
              setDataForRequest(props?.data?.VendorRequirementRegistrationId)
              setDataForRequestVendorCode(props?.data?.VendorCode)
            }

          }}
        >
        </button>
        {props?.data?.VendorRequirementRegistrationId && permissions.View && (
          <button
            title="View"
            className="View mr-2"
            type="button"
            onClick={handleView}
          >

          </button>
        )}
      </div>
    );
  };
  const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
    return (
      <>
        <label htmlFor="normal-switch" className="normal-switch">
          <Switch
            // onChange={() => handleChange(cell, row, enumObject, rowIndex)}
            checked={cell}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            id="normal-switch"
            height={24}
          />
        </label>
      </>
    );
  };
  const checkBoxRenderer = (props) => {
    let selectedRowForPagination =
      reactLocalStorage.getObject("selectedRow").selectedRow;
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    if (selectedRowForPagination?.length > 0) {
      selectedRowForPagination.map((item) => {
        if (
          item.VendorCode ===
          props.node.data.VendorCode
        ) {
          props.node.setSelected(true);
        }
        return null;
      });
      return cellValue;
    } else {
      return cellValue;
    }
  };
  /**
   * @method effectiveDateFormatter
   * @description Renders buttons
   */

  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    effectiveDateRenderer:effectiveDateFormatter,
    customFloatingFilter: CustomDateRangeFilter,
    statusButtonFormatter: statusButtonFormatter,
    // hyphenFormatter: hyphenFormatter,
    customNoRowsOverlay: NoContentFound,
    checkBoxRenderer: checkBoxRenderer,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };

  // const { loading } = useSelector((state) => state?.AllSupplierHistorySlice);
  return (
    <>
      {
        vendorUnblockingRequest === "main" ? (
          <>
            {loader  ? (
              <LoaderCustom customClass="simulation-Loader" />
            ) : (
              <><div className="w-100 pt-0 pl-0 pb-0 pr-0">
                <Row className="ag-grid-react custom-pagination">
                  <Col md={12}>
                    <div
                      className={`ag-grid-wrapper ${props?.isDataInMaster && !props?.noData
                        ? "master-approval-overlay"
                        : ""} ${(props?.allSupplierListing?.data &&
                          props?.allSupplierListing?.data?.data?.length <= 0) ||
                          props?.noData
                          ? "overlay-contain"
                          : ""}`}
                    >
                      <div
                        className={`ag-theme-material ${props?.loading && "max-loader-height"}`}
                      >
                        {props?.noData && (
                          <NoContentFound
                            title={EMPTY_DATA}
                            customClassName="no-content-found" />
                        )}
                        <Row className={`filter-row-large`}>
                          <Col md="12" className="mb-3 d-flex justify-content-end">
                            <div className="d-flex justify-content-end bd-highlight w100">
                              <Col
                                md="9"
                                lg="9"
                                className="mb-3 d-flex justify-content-end"
                              >
                                {
                                  // SHOW FILTER BUTTON ONLY FOR RM MASTER NOT FOR SIMULATION AMD MASTER APPROVAL SUMMARY
                                  !props.isMasterSummaryDrawer && (
                                    <>
                                      {isSimulation && (
                                        <div className="warning-message d-flex align-items-center">
                                          {warningMessage && !disableDownload && (
                                            <>
                                              <WarningMessage
                                                dClass="mr-3"
                                                message={"Please click on filter button to filter all data"} />
                                              <div className="right-hand-arrow mr-2"></div>
                                            </>
                                          )}

                                          <Button
                                            id="rmDomesticListing_filter"
                                            className={"mr5 Tour_List_Filter"}
                                            onClick={() => onSearch()}
                                            title={"Filtered data"}
                                            icon={"filter"}
                                            disabled={disableFilter} />
                                        </div>
                                      )}
                                      {!isSimulation && (
                                        <div className="d-flex justify-content-end bd-highlight w100">
                                          <>
                                            {(props?.isMasterSummaryDrawer ===
                                              undefined ||
                                              this.props?.isMasterSummaryDrawer ===
                                              false) && (
                                                <div className="warning-message d-flex align-items-center">
                                                  {warningMessage &&
                                                    !disableDownload && (
                                                      <>
                                                        <WarningMessage
                                                          dClass="mr-3"
                                                          message={"Please click on filter button to filter all data"} />
                                                        <div className="right-hand-arrow mr-2"></div>
                                                      </>
                                                    )}
                                                </div>
                                              )}
                                            {(props?.isMasterSummaryDrawer ===
                                              undefined ||
                                              this.props?.isMasterSummaryDrawer ===
                                              false) && (
                                                <Button
                                                  id="rmDomesticListing_filter"
                                                  className={"mr5 Tour_List_Filter"}
                                                  onClick={() => onSearch()}
                                                  title={"Filtered data"}
                                                  icon={"filter"}
                                                  disabled={disableFilter} />
                                              )}
                                          </>
                                        </div>
                                      )}
                                    </>
                                  )}
                              </Col>

                              <div>
                                <ExcelFile
                                  filename={'BlockedEmployerExport'}
                                  fileExtension={".xls"}
                                  element={<button
                                    title={`Download ${dataCount === 0
                                      ? "All"
                                      : "(" + dataCount + ")"}`}
                                    type="button"
                                    className={"user-btn mr5 Tour_List_Download"}
                                  >
                                    <div className="download mr-1"></div>
                                    {`${dataCount === 0
                                      ? "All"
                                      : "(" + dataCount + ")"}`}
                                  </button>}
                                >
                                  {onBtExport()}
                                </ExcelFile>
                              </div>
                              <Button
                                id={"rmDomesticListing_refresh"}
                                className={"Tour_List_Reset"}
                                onClick={() => resetState()}
                                title={"Reset Grid"}
                                icon={"refresh"} />
                            </div>
                          </Col>
                        </Row>
                        <div
                          className={`hl-ag-theme-material ${(props?.usersWithSerialNumbers &&
                            props?.usersWithSerialNumbers?.length <= 0) ||
                            noData
                            ? "overlay-contain"
                            : ""}`}
                        >
                          <AgGridReact
                            defaultColDef={defaultColDef}
                            floatingFilter={true}
                            domLayout="autoHeight"
                            pagination={true}
                            rowData={props?.usersWithSerialNumbers}
                            onSortChanged={props?.onSortChanged}
                            paginationPageSize={props?.globalTake}
                            onPageSizeChanged={onPageSizeChanged}
                            onGridReady={onGridReady}
                            onRowSelected={onRowSelect}
                            rowSelection={"multiple"}
                            onFilterModified={onFloatingFilterChanged}
                            gridOptions={gridOptions}
                            noRowsOverlayComponent={"customNoRowsOverlay"}
                            noRowsOverlayComponentParams={{
                              title: EMPTY_DATA,
                              imagClass: "imagClass",
                            }}
                            frameworkComponents={frameworkComponents}
                            enableBrowserTooltips={false}
                          >
                            <AgGridColumn
                              cellClass="has-checkbox"
                              field="VendorCode"
                              floatingFilter={true}
                              headerName="Supplier Code"
                              cellRenderer={checkBoxRenderer}
                            ></AgGridColumn>
                            <AgGridColumn
                              field="SupplierName"
                              floatingFilter={true}
                              headerName="Supplier Name"
                              // sortable={true}
                              // unSortIcon={true}
                              comparator={(
                                valueA,
                                valueB,
                                nodeA,
                                nodeB,
                                isInverted
                              ) => valueA
                                .toLowerCase()
                                .localeCompare(valueB.toLowerCase())}
                            ></AgGridColumn>
                            <AgGridColumn
                              field="VendorCategory"
                              floatingFilter={true}
                              headerName="Supplier Category"
                              // sortable={true}
                              // unSortIcon={true}
                              comparator={(
                                valueA,
                                valueB

                              ) => valueA
                                .toLowerCase()
                                .localeCompare(valueB.toLowerCase())}
                            ></AgGridColumn>
                            <AgGridColumn
                              field="BlockReason"
                              floatingFilter={true}
                              headerName="Reason For Blocking"
                              // sortable={true}
                              // unSortIcon={true}
                              comparator={(
                                valueA,
                                valueB

                              ) => valueA
                                .toLowerCase()
                                .localeCompare(valueB.toLowerCase())}
                            ></AgGridColumn>
                          
                            <AgGridColumn field="RegistrationDate" cellRenderer='effectiveDateRenderer' filter="agDateColumnFilter" filterParams={filterParams}></AgGridColumn>



                            <AgGridColumn
                              field="EmailAddress"
                              headerName="Email Address"
                              floatingFilter={true}
                            ></AgGridColumn>
                            <AgGridColumn
                              field="ContactNumber"
                              floatingFilter={true}
                              headerName="Contact Number"
                            ></AgGridColumn>
                            <AgGridColumn
                              headerName="Action"
                              cellRenderer={"totalValueRenderer"}
                              type="rightAligned"
                            ></AgGridColumn>
                          </AgGridReact>
                        </div>
                        <div className="button-wrapper">
                          <PaginationWrapper
                            gridApi={gridApi}
                            setPage={onPageSizeChanged}
                            globalTake={props?.globalTake}
                          />
                          {/* {pageNo} */}
                          {(props?.isMasterSummaryDrawer === undefined ||
                            props?.isMasterSummaryDrawer === false) &&
                            (filter === "1" ? (
                              <CustomPagination
                                total={blockedSuppliers?.TotalItems}
                                page={pageNo}
                                pageSize={pageSize}
                                OnPrev={onBtPrevious}
                                onNext={onBtNext} />
                            ) : (
                              <CustomPagination
                                total={blockedSuppliers?.TotalItems || 0}
                                page={pageNo}
                                pageSize={pageSize}
                                onNext={(nextPage, pSize) => {
                                  onBtNext(nextPage, pSize);
                                }}
                                OnPrev={(prevPage, pSize) => {
                                  onBtPrevious(prevPage, pSize);
                                }}
                              />
                            ))}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              </>
            )}
          </>
        ) : (
          vendorUnblockingRequest === "add" && <AddUnblockingRequest VendorRegID={dataForRequest} SupplierCodeId={dataForRequestVendorCode} />
        )
      }

    </>

  );
};

export default BlockedEmployer;
